<template>
  <el-row class="QA-check-inside" v-if="filterQaStatus()">
    <el-col :span="24" class="QA-check-info">
      <div class="left">
        <span class="first">条目数</span>
        <span class="last">{{getQAList&&(getQAList.length) || 0}}</span>
      </div>
      <div class="right">
        <el-button type="primary" size="small"
                   :class="{'disabled-buttom':getFileTaskInfo&&(parseInt(getFileTaskInfo.finish)===1)}"
                   :disabled="getFileTaskInfo&&(parseInt(getFileTaskInfo.finish)===0)"
                   @click="()=>handleIgnoreRecovery('ignore')">
          全部忽略
        </el-button>
        <el-button type="primary" size="small"
                   :class="{'disabled-buttom':getFileTaskInfo&&(parseInt(getFileTaskInfo.finish)===1)}"
                   :disabled="getFileTaskInfo&&(parseInt(getFileTaskInfo.finish)===0)"
                   @click="()=>handleIgnoreRecovery('recovery')">
          全部恢复
        </el-button>
      </div>
    </el-col>
    <el-col :span="24" class="QA-content-area">
      <el-row class="QA-header">
        <el-col :span="3">句段编号</el-col>
        <el-col :span="9">错误描述</el-col>
        <el-col class="last" :span="6">严重级别</el-col>
        <el-col class="last" :span="6">状态</el-col>
      </el-row>
      <div class="QA-content-wrap">
        <div class="QA-content" v-for="(item , index) in getQAList" :key="`${index}-$(item.id)`"
             :sid='item.transFileSentId'
             :class="{'last-content': (getQAList.length===(index+1))&&(getQAList.length>=2)}">
          <el-col :span="3" class="item">
            {{getTaskContentList(item) || (index+1).toString().padStart(2, '0')}}</el-col>
          <el-col :span="9" class="item">{{item.description}}</el-col>
          <el-col :span="6" class="item-special">{{errLevel(item)}}</el-col>
          <el-col :span="6" class="item-state">
            <el-button size="mini"
                       :disabled="getFileTaskInfo&&(parseInt(getFileTaskInfo.finish)===0)"
                       v-if="item['isIgnore']===0"
                       @click="()=>handleIgnoreRecoveryAlone(item,'ignore')">
              忽略
            </el-button>
            <el-button size="mini"
                       :disabled="getFileTaskInfo&&(parseInt(getFileTaskInfo.finish)===0)"
                       v-if="item['isIgnore']===1"
                       @click="()=>handleIgnoreRecoveryAlone(item,'recovery')">
              恢复
            </el-button>
          </el-col>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTaskStatusAjax } from "@/services/editorApi"
export default {
  name: "QACheck",
  data () {
    return {
      options: [{
        value: "1",
        label: '轻微错误'
      }, {
        value: "2",
        label: '一般错误'
      }, {
        value: "3",
        label: '严重错误'
      }],
      value: '3',
      value1: true,
      id: "",
      fileTaskStatus: {},//文件状态
      taskType: 0, //任务类型
    };

  },

  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',               // 路由信息
      'getQAList',                // QA列表
      "getProjectInfo", // 获取项目信息
    ]),
    //获取任务信息
    getFileTaskInfo () {
      let fileTaskInfo = null;
      const { type } = this.getUrlInfo
      if (type === 'project') {
        fileTaskInfo = this.$store.getters['editor/getFileInfo'];
      } else if (type === 'task' || type === 'school') {
        fileTaskInfo = this.$store.getters['editor/getFileTaskInfo'];
      }
      return fileTaskInfo;
    },
    //获取QA的序号
    getTaskContentList () {
      return function (row) {
        const { transFileSentId } = row
        if (transFileSentId) {
          const { transSentRespVoList } = (this.$store.getters['editor/getTaskContentList']);
          let $index = 0
          if (transSentRespVoList && transSentRespVoList.length) {
            transSentRespVoList.every((item, index) => {
              if (parseInt(transFileSentId) === parseInt(item.id)) {
                $index = index + 1
                return false
              } else {
                return true
              }
            })
          }
          return $index.toString().padStart(2, '0')
        }
        // if (!!row && !!(row.transFileSentId)) {
        //   let taskContentList = (this.$store.getters['editor/getTaskContentList']);
        //   let indexSent = 0;
        //   if (!!taskContentList && !!(taskContentList.transSentRespVoList)) {
        //     (taskContentList.transSentRespVoList).every((item, index) => {
        //       if (parseInt(row.transFileSentId) === parseInt(item.id)) {
        //         indexSent = (index + 1);
        //         return false
        //       } else {
        //         return true
        //       }
        //     });
        //     console.log(indexSent, 'indexSent');
        //     return indexSent.toString().padStart(2, '0')
        //   }
        // }
      }
    }
  },

  mounted () {
    this.getQAStateInfo();
    this.taskType = (JSON.parse(this.$Base64.decode(this.$route.query.key))) || {};
    // console.log(this.taskType, "this.taskType ");
    this.getTaskStatus()
  },

  methods: {
    //筛选qa状态
    filterQaStatus () {
      // console.log(this.taskType.taskType, "this.taskType.taskType",this.fileTaskStatus);
      switch (this.taskType.taskType) {
        case 1:
          return true
          break;
        case 2:
          //如果是译审同步，翻译没完成也要显示QA
          if(this.getProjectInfo.isSyncTransReview == 1){
            return true
          }else{
            if (this.fileTaskStatus.transStatus === 1) {
              return true
            } else {
              return false
            }
          }
          break;
        case 3:
           //如果是译审同步，翻译没完成也要显示QA
           if(this.getProjectInfo.isSyncTransReview == 1){
            return true
          }else{
            if (this.fileTaskStatus.reviewStatus === 1) {
            return true
          } else {
            return false
          }
          }
          break;

        default:
          break;
      }
    },
    //获取qa状态
    getTaskStatus () {
      setTimeout(async () => {
        let UrlInfo = this.getUrlInfo
        const { result, success } = await getTaskStatusAjax({ fileId: UrlInfo.fileId });
        if (success) {
          // transStatus  翻译状态  reviewStatus  审校状态
          this.fileTaskStatus = { ...result }
        }
      }, 500)
    },
    //忽略--恢复
    handleIgnoreRecoveryAlone (item, type) {
      let target = event.target;
      if (target.nodeName === "SPAN") {
        target = event.target.parentNode;
      }
      // console.log(event, target);
      target.blur();
      let arr = Array();
      let params = Object();
      let getFileTaskInfo = this.getFileTaskInfo;
      if (!(getFileTaskInfo && (parseInt(getFileTaskInfo.finish) === 1))) {
        if (item.id) {
          arr.push((item.id));
          Reflect.set(params, 'ids', arr);
          Reflect.set(params, 'projectId', getFileTaskInfo.projectId);
          if (type === 'ignore') {
            this.$store.dispatch('editor/ignoreQAFileTaskInfo', params)
          } else if (type === 'recovery') {
            this.$store.dispatch('editor/recoveryQAFileTaskInfo', params)
          }
        } else {
          this.$message.closeAll();
          this.$message.warning('没有可操作的数据');
        }
      } else {
        this.$message.closeAll();
        this.$message.warning('已提交，不能修改状态')
      }
    },

    //忽略全部--恢复全部
    handleIgnoreRecovery (type) {
      let QAMap = new Map();
      let params = Object();
      let getFileTaskInfo = this.getFileTaskInfo;
      // console.log(getFileTaskInfo)
      if ((getFileTaskInfo && !(parseInt(getFileTaskInfo.finish) === 1))) {
        let QAList = [...this.getQAList]
        QAList.forEach((item) => {
          QAMap.set((item.id), item)
        });
        let idList = [...QAMap.keys()];
        if (idList.length) {
          Reflect.set(params, 'ids', idList);
          Reflect.set(params, 'projectId', getFileTaskInfo.projectId);
          if (type === 'ignore') {
            this.$store.dispatch('editor/ignoreQAFileTaskInfo', params)
          } else if (type === 'recovery') {
            this.$store.dispatch('editor/recoveryQAFileTaskInfo', params)
          }
        } else {
          this.$message.closeAll();
          this.$message.warning('没有可操作的数据');
        }
      } else {
        this.$message.closeAll();
        this.$message.warning('已提交，不能修改状态')
      }
    },

    getQAStateInfo () {
      let QAState = JSON.parse((localStorage.getItem("QAState") || false));
      this.value1 = QAState;
      this.$store.dispatch('editor/setQAStateInfo', QAState);
    },

    //改变整体
    handleChangeQAState (value) {
      localStorage.setItem('QAState', JSON.stringify(value));
      this.value1 = value;
      this.$store.dispatch('editor/setQAStateInfo', value);
    },

    //错误级别
    errLevel (item) {
      if (!!item && !!(item.grade)) {
        switch (parseInt(item.grade)) {
          case 0:
            return '轻微错误';
          case 1:
            return '一般错误';
          case 2:
            return '严重错误';
          default:
            return '轻微错误';
        }
      } else {
        return '轻微错误';
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "assets/style.less";
</style>